// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { Link } from 'react-router';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertDate, convertPrice, createPaxAges } from '@/_helper/mapper';
import { checkAccess } from '../_helper/checkAccess';
import { chipClass } from '../_helper/mapper';

// Komponenten
import ExcursionSlider from '../_comp/slider/slider';
import LoadingOffersBar from '@/comp/loadingOffersBar';
import BackButton from '@/comp/backButton/backButton';
import { MapOverlayContainer } from '@/comp/map/Map';

// Styles
import './index.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

class Excursion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: 0,
            data: [],
            isLoading: false,
            hasResult: false,
            error: null,
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : null,
            showFilter: false,
            map: {
                popupId: null,
            },
            filter: {
                map: {
                    state: 'close',
                },
                chips: [],
                sort: {
                    state: 'close',
                    current: 'price_asc',
                    list: {
                        price_asc: {
                            title: 'Preis: niedrigster zuerst',
                        },
                        price_desc: {
                            title: 'Preis: höchster zuerst',
                        },
                    },
                },
            },
        };

        this.getHandleHideMap = this.getHandleHideMap.bind(this);
    }

    componentDidMount() {
        // not allowed to book
        checkAccess('allowExtraServicesExcursion');

        let $this = this;
        let offers = storage.get('excursionOffers');

        function setOffers(data) {
            if (data?.excursionOffers === undefined) {
                return false;
            }
            let excursionOffers = [];
            Object.keys(data.excursionOffers).forEach((value, index) => {
                // set filter parameter : show
                let v = data.excursionOffers[value];
                v['show'] = true;
                excursionOffers.push(v);
            });

            $this.setState({
                data: data,
                excursionOffers: excursionOffers,
                isLoading: false,
            });
        }

        if (offers !== null) {
            setOffers(offers.data);

            return false;
        }

        // loading state
        this.setState({ isLoading: true });

        let searchParams = undefined;
        if (this.state.bookingData !== null) {
            searchParams = this.state.bookingData?.data?.searchParams;
        }

        if (searchParams !== undefined) {
            const sendData = {
                requestType: 'searchExtra',
                clientId: 'customerarea',
                travelType: 'excursion',
                hotelCode: searchParams.hotelCode,
                regionCode: searchParams.destination,
                arrivalAirportCode: searchParams.retAirport,
                travelStart: convertDate(searchParams.depDate),
                travelEnd: convertDate(searchParams.retDate),
                paxAges: createPaxAges(searchParams.paxAges),
            };

            axios({
                url: window.$requestUrl + '/searchExtra?token=' + window.$token,
                method: 'POST',
                data: JSON.stringify(sendData),
            })
                .then((response) => response)
                .then((data) => {
                    let r = data.data.data;

                    if (r !== undefined) {
                        this.setState({
                            data: r,
                            hasResult: true,
                        });

                        setOffers(r);

                        storage.set('excursionOffers', {
                            data: r,
                        });
                    } else {
                        this.setState({
                            error: true,
                            isLoading: false,
                        });
                    }
                })
                .catch((error) => this.setState({ error, isLoading: false }));
        }

        if (storage.get('bookingData') !== null && storage.get('bookingData').bookingParams !== undefined) {
            this.setState({
                bookingParams: storage.get('bookingData').bookingParams,
            });
        } else {
            this.getBookingParams();
        }
    }

    getBookingParams() {
        if (storage.get('access_token') !== null) {
            const loginData = {
                requestType: 'bookingData',
                bookingId: storage.get('bookingNumber'),
                action: 'getBookingParams',
                clientId: 'customerarea',
                requestSource: 'AurumTours-Customerarea',
                hash: storage.get('access_token'),
            };

            axios({
                url: window.$serviceUrl + '/bookingData?token=' + window.$token,
                method: 'POST',
                data: loginData,
            })
                .then((response) => response)
                .then((data) => {
                    let response = data.data.data.data;

                    if (response !== null) {
                        this.setState({
                            bookingParams: response,
                        });

                        let bookingData = _.assign(storage.get('bookingData'), {
                            bookingParams: response,
                        });

                        storage.set('bookingData', bookingData);
                    } else {
                        this.setState({
                            loading: false,
                            hasError: true,
                        });
                    }
                })
                .catch((error) => this.setState({ error }));
        }
    }

    mapTrigger() {
        let { excursionOffers, filter } = this.state;

        let $this = this;

        if (excursionOffers !== undefined && excursionOffers.length === 0) {
            return false;
        }

        function handleClick() {
            let filterArr = { ...filter };
            switch (filterArr.map.state) {
                case 'open':
                    filterArr.map.state = 'close';
                    break;
                case 'close':
                    filterArr.map.state = 'open';
                    break;
                default:
            }
            $this.setState({ filter: filterArr });
        }

        return (
            <div className={`map-trigger filter-call ${filter.map.state}`} onClick={(e) => handleClick()}>
                <i className="material-icons">location_on</i>
                <span>Karte</span>
            </div>
        );
    }

    getHandleHideMap(e) {
        let { filter } = this.state;

        if (e !== undefined) {
            if (e === false) {
                let filterArr = { ...filter };
                filterArr.map.state = 'close';
                this.setState({ filter: filterArr });
            }
        }

        return this.state.filter;
    }

    sortTrigger() {
        let { excursionOffers, filter } = this.state;

        let $this = this;

        if (excursionOffers !== undefined && excursionOffers.length === 0) {
            return false;
        }

        const sortList = (e, sort) => {
            let sortList = excursionOffers;

            switch (sort) {
                case (sort = 'price_asc'):
                    sortList = _.orderBy(
                        excursionOffers,
                        [
                            function (item) {
                                return item.price.pricePerPerson;
                            },
                        ],
                        ['asc']
                    );
                    break;
                case (sort = 'price_desc'):
                    sortList = _.orderBy(
                        excursionOffers,
                        [
                            function (item) {
                                return item.price.pricePerPerson;
                            },
                        ],
                        ['desc']
                    );
                    break;
                case (sort = 'startDate_asc'):
                    sortList = _.orderBy(excursionOffers, ['startDate'], ['asc']);
                    break;
                case (sort = 'startDate_desc'):
                    sortList = _.orderBy(excursionOffers, ['startDate'], ['desc']);
                    break;
                default:
            }

            let filterArr = filter;
            filterArr.sort.state = 'close';
            filterArr.sort.current = sort;

            $this.setState({
                excursionOffers: sortList,
                filter: filterArr,
            });
        };

        return (
            <div className={`sort-trigger filter-call ${filter.sort.state}`}>
                <div
                    className="current"
                    onClick={(e) => {
                        let filterArr = { ...filter };
                        switch (filterArr.sort.state) {
                            case 'open':
                                filterArr.sort.state = 'close';
                                break;
                            case 'close':
                                filterArr.sort.state = 'open';
                                break;
                            default:
                        }
                        $this.setState({ filter: filterArr });
                    }}>
                    <i className="material-icons">compare_arrows</i>
                    <span>{filter.sort.list[filter.sort.current].title}</span>
                </div>
                <div className="options">
                    {Object.keys(filter.sort.list).map(
                        (value, index) =>
                            filter.sort.current !== value && (
                                <div key={index} onClick={(e) => sortList(e, value)}>
                                    {filter.sort.list[value].title}
                                </div>
                            )
                    )}
                </div>
            </div>
        );
    }

    chips() {
        let $this = this;

        let chips = [];
        let filter = $this.state.filter;

        // set categories with count
        function setCategories(arr) {
            var a = [],
                b = [],
                prev;

            arr.sort();
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] !== prev) {
                    a.push(arr[i]);
                    b.push(1);
                } else {
                    b[b.length - 1]++;
                }
                prev = arr[i];
            }

            return [a, b];
        }

        function handleClickChip(item) {
            let data = $this.state.data;

            if (filter.chips.includes(item)) {
                filter.chips = filter.chips.filter(function (value) {
                    return value !== item;
                });
            } else {
                filter.chips.push(item);
            }

            Object.keys(data.excursionOffers).forEach((value, index) => {
                if (filter.chips.length > 0) {
                    if (filter.chips.includes(data.excursionOffers[value].category)) {
                        data.excursionOffers[value].show = true;
                    } else {
                        data.excursionOffers[value].show = false;
                    }
                } else {
                    data.excursionOffers[value].show = true;
                }
            });

            $this.setState({
                data: data,
                filter: filter,
            });
        }

        let categories = setCategories(_.map(this.state.excursionOffers, 'category'));

        categories[0].forEach((item, key) => {
            chips.push(
                <div
                    key={key}
                    className={`chip ${filter.chips.length > 0 && filter.chips.includes(item) ? 'selected' : ''}`}
                    onClick={(e) => handleClickChip(item)}>
                    {item} ({categories[1][key]})
                </div>
            );
        });

        return <div className="chips">{chips}</div>;
    }

    filterBar() {
        return (
            <div className={`filter-bar ${this.state.showFilter ? 'active' : ''}`}>
                <span
                    className="close"
                    onClick={() => {
                        this.setState({ showFilter: !this.state.showFilter });
                        document.querySelector('.page-excursion').classList.remove('filter-open');
                    }}>
                    zurück
                </span>

                <button
                    className="button filter-button flex-between"
                    onClick={(e) =>
                        window.innerWidth <= 900
                            ? (this.setState({ showFilter: !this.state.showFilter }),
                              document.querySelector('.page-excursion').classList.remove('filter-open'))
                            : ''
                    }>
                    <div title="jetzt filtern">Ergebnisse filtern</div>
                </button>
                <div className="main-content">
                    <div className="filter ">
                        <div className="cnt">
                            <h4 className="subheadline">Ausflüge sortieren nach</h4>
                            {this.sortTrigger()}
                        </div>
                    </div>
                    <div className="filter ">
                        <h4 className="subheadline">Typ des Ausflugs</h4>
                        <div className="cnt">{this.chips()}</div>
                    </div>
                </div>
            </div>
        );
    }

    cards() {
        // Config Excursion Slider
        const SliderSettings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };

        let $this = this;
        let $excursionOffers = this.state.excursionOffers;

        // generate cards
        let cards = [];

        if (this.state.data && this.state.excursionOffers !== undefined) {
            if ($excursionOffers.length === 0) {
                return (
                    <div>
                        <div className="error offers">Es wurden keine passende Angebote für Sie gefunden.</div>
                        <div className="user-action">
                            <BackButton class="col" target="blank" />
                        </div>
                    </div>
                );
            }

            Object.keys(this.state.excursionOffers).forEach((k) => {
                const {
                    title,
                    category,
                    images,
                    highlight,
                    distanceToAccommodation,
                    price,
                    supplierOfferId,
                    resort,
                    show,
                } = $excursionOffers[k];

                // sizes | original , display , thumbnail
                let imagesSize = [];
                images.forEach((item) => {
                    let con = item.replace(/original/gi, 'display');
                    imagesSize.push(con);
                });

                let tmpl = (
                    <div key={k} className="entry" category={category}>
                        <div className="cnt">
                            <div className="image-sec col">
                                {window.$browserInfo.device === 'mobile' && (
                                    <div className="counter">
                                        {imagesSize.length} <i className="material-icons">photo_camera</i>
                                    </div>
                                )}
                                <ExcursionSlider settings={SliderSettings} images={imagesSize} />
                                <div className="dots">
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot active"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                </div>
                            </div>
                            <div className="content col">
                                <div className="top">
                                    <div className="title">{title}</div>

                                    <div className="infos">
                                        <div className={'chip ' + chipClass(category)}>{category}</div>

                                        <div
                                            className="location"
                                            onClick={(e) => {
                                                let { filter, map } = this.state;

                                                let filterArr = { ...filter };
                                                filterArr.map.state = 'open';
                                                this.setState({ filter: filterArr });

                                                let mapArr = { ...map };
                                                mapArr.popupId = 0;
                                                this.setState({ map: mapArr });
                                                _.delay(function () {
                                                    mapArr.popupId = k;
                                                    $this.setState({ map: mapArr });
                                                }, 0);

                                                if (window.$browserInfo.device !== 'mobile') {
                                                    document.querySelector('#map-ref').scrollIntoView({
                                                        behavior: 'smooth',
                                                        block: 'start',
                                                        inline: 'nearest',
                                                    });
                                                }
                                            }}>
                                            <i className="large material-icons">place</i> {resort}
                                        </div>

                                        {distanceToAccommodation !== undefined &&
                                            distanceToAccommodation.toString().length > 0 && (
                                                <div className="distance-to-hotel-booked">
                                                    {distanceToAccommodation.toFixed(1).toString().replace('.', ',')} km
                                                    vom Hotel entfernt
                                                </div>
                                            )}
                                    </div>
                                </div>

                                <div className="sub">
                                    <div
                                        className={
                                            'description ' +
                                            (window.innerWidth > 640 && highlight.length > 145 ? 'hide' : '')
                                        }
                                        onClick={(e) => {
                                            let elem = e.target;
                                            if (window.innerWidth > 640 && highlight.length > 145) {
                                                if (!elem.classList.contains('active')) {
                                                    e.target.innerHTML = highlight;
                                                } else {
                                                    e.target.innerHTML = highlight.substring(0, 145) + '...';
                                                }
                                                e.target.classList.toggle('active');
                                            }
                                        }}>
                                        {window.innerWidth > 640 && highlight.length > 145
                                            ? highlight.substring(0, 145) + '...'
                                            : highlight}
                                    </div>

                                    <div className="details">
                                        <div className="total-price">
                                            <div>
                                                <span>ab</span> {price.pricePerPerson >= 0 ? '+' : '-'}{' '}
                                                {convertPrice(price.pricePerPerson, 0, 0)}
                                            </div>
                                            <div className="small-print">pro Person</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="user-action">
                            <Link to={`/ausfluege/details/${supplierOfferId}`} className="button link" target="_blank">
                                jetzt auswählen
                            </Link>
                        </div>
                    </div>
                );

                show && cards.push(tmpl);
            });
        }

        return <>{cards}</>;
    }

    render() {
        const { isLoading, error, hasResult } = this.state;

        if (error || this.state.data === undefined) {
            return (
                <div>
                    <div className="error">{window.$content.errorText}</div>
                    <div className="user-action">
                        <BackButton class="col" target="blank" />
                    </div>
                </div>
            );
        }

        if (isLoading) {
            if (hasResult) {
                setTimeout(() => {
                    this.setState({
                        isLoading: false,
                    });
                }, 2000);
            }
            return <LoadingOffersBar hasResult={hasResult} />;
        }

        return (
            <>
                <div className="user-action">
                    {this.chips()}

                    <div className="filter-action">
                        {this.mapTrigger()}
                        {this.sortTrigger()}
                    </div>

                    {this.state.excursionOffers !== undefined && this.state.excursionOffers.length > 0 && (
                        <>
                            <div
                                className="filter-trigger"
                                onClick={(e) => {
                                    this.setState({ showFilter: !this.state.showFilter });
                                    document.querySelector('.page-excursion').classList.add('filter-open');
                                }}>
                                <i className="material-icons">filter_list</i> Filter
                            </div>

                            {/* filterBar */}
                            {this.filterBar()}
                        </>
                    )}
                </div>

                {/* Map */}
                <div id="map-ref"></div>
                {this.state.excursionOffers !== undefined &&
                    this.state.excursionOffers.length > 0 &&
                    this.state.filter.map.state === 'open' && (
                        <>
                            <MapOverlayContainer
                                offers={_.filter(this.state.excursionOffers, { show: true })}
                                popup={this.state.map.popupId}
                                handleHideMap={this.getHandleHideMap}
                            />
                        </>
                    )}

                <div className="entries">{this.cards()}</div>
            </>
        );
    }
}

export default Excursion;
